import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingAnimation from "components/UI/Loader";
import { fetchOrdersWithSeals } from "redux/logistics/ordersSlice";
import { fetchLanes } from "redux/warehouse/lanesSlice";
import { modifyOrder } from "components/Apis/orders";

export const SealsTab = () => {
  const dispatch = useDispatch();

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const { lanes } = useSelector((state) => state.lanes);
  const { loading, error, orders } = useSelector((state) => state.orders.ordersWithSeals);

  const totalPages = orders?.count ? Math.ceil(orders.count / pageSize) : 1;

  useEffect(() => {
    dispatch(fetchLanes());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchOrdersWithSeals({ ...filters, page, page_size: pageSize }));
  }, [filters, page, pageSize, dispatch]);

  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e.target.value));
    setPage(1);
  };

  return (
    <div className="main-container m-view">
      <div className="pulse-content pt-2">
        {/* Filters */}
        <div className="filters-panel">
          <div className="search-row">
            <div className="form-group w-100">
              <label>Search</label>
              <input
                type="text"
                className="input thin form-control"
                placeholder="Search logs..."
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, search: e.target.value }))
                }
              />
            </div>
          </div>

          <div className="filters-row">
            <div className="form-group">
              <label>Lane</label>
              <select
                value={filters.lane || ""}
                className="input thin form-control"
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, lane: e.target.value }))
                }
              >
                <option value="">All Lanes</option>
                {lanes?.filter((lane) =>
                  lane.short_form_name.includes("MX NB") || lane.short_form_name.includes("MX SB")
                ).map((lane) => (
                  <option key={lane.id} value={lane.id}>
                    {lane.short_form_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Start Date</label>
              <input
                type="date"
                className="input thin form-control"
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, startDate: e.target.value }))
                }
              />
            </div>
            <div className="form-group">
              <label>End Date</label>
              <input
                type="date"
                className="input thin form-control"
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, endDate: e.target.value }))
                }
              />
            </div>
          </div>
        </div>

        <hr style={{ marginLeft: 0, marginRight: 0 }} />

        {/* Table */}
        <div className="logs-table-container">
          <table className="table-striped logs-table">
            <thead>
              <tr>
                <th>Pro #</th>
                <th>Mx Carrier</th>
                <th>Trailer/ Placas</th>
                <th>Vehicle</th>
                <th>Deliver To</th>
                <th>Lane</th>
                <th>Seal</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center">
                    <div className="loading-container">
                      <LoadingAnimation />
                    </div>
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="7" className="text-center">
                    <div className="error">
                      <h3>Error: {error}</h3>
                    </div>
                  </td>
                </tr>
              ) : orders?.results?.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center">
                    <div className="no-data">No logs found.</div>
                  </td>
                </tr>
              ) : (
                orders?.results.map((order) => (
                  <tr key={order.id}>
                    <td>{order.order_no} {order.order_group} {order.backorder?.order_no}</td>
                    <td>{order.mx_carrier}</td>
                    <td>{order.trailer_placas}</td>
                    <td>{order.vehicle_size}</td>
                    <td>{order.delivery_city_state}</td>
                    <td>{order.lane}</td>
                    <td>
                      <input
                        className="input super-thin bg-white"
                        defaultValue={order.seal}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            const newSeal = e.target.value;
                            modifyOrder({
                              id: order.id,
                              seal: newSeal,
                            });
                          }
                        }}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <hr style={{ marginLeft: 0, marginRight: 0 }} />

        {/* Pagination */}
        {orders?.results && (
          <div className="pagination-controls d-flex align-items-center justify-content-between pb-2 pt-0 mt-0 flex-wrap gap-2">
            <div className="d-flex align-items-center gap-4">
              <button
                className="button btn-sm"
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={!orders.previous}
              >
                <i className="fa fa-chevron-left"></i>
              </button>
              <span className="mx-3">Page {page} of {totalPages}</span>
              <button
                className="button btn-sm"
                onClick={() => setPage((prev) => prev + 1)}
                disabled={!orders.next}
              >
                <i className="fa fa-chevron-right"></i>
              </button>
            </div>

            <div className="d-flex align-items-center gap-2 no-wrap">
              <label className="mb-0">Page Size:</label>
              <select
                className="form-control input-sm"
                value={pageSize}
                onChange={handlePageSizeChange}
              >
                {[10, 25, 50, 100].map((size) => (
                  <option key={size} value={size}>{size}</option>
                ))}
              </select>
              <span className="text-muted ml-2">Total: {orders.count} results</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
